import React, { useEffect, useMemo, useState } from "react";
import {
	AntdButton,
	TableContainer,
	AntdTable,
	ConfirmButton,
	Inner,
	HeaderContainer,
} from "./styles";
import { Input, Modal } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingSkeleton from "./components/LoadingSkeleton";
import { debounce } from "lodash";
import { useAuth } from "../../../../../contexts/authContext";
import {
	openNotificationWithIcon,
	TYPE,
} from "../../../../../utils/notificationToast";
import { COLORS } from "../../../../layout/theme";
import Main from "../../../../layout/main/Main";
import {
	get_import_order_history_detail,
	resend_order_items,
	update_import_order_item_data,
} from "../../../../../api/endpoints/orders";

export default function UpdateFailedOrder({ clientId }) {
	const navigate = useNavigate();
	const { id } = useParams();
	const { user, userdata } = useAuth();
	const [data, setData] = useState(false);
	const [state, setState] = useState("ACTIVE");
	const [hasChanges, setHasChanges] = useState(false);
	const [key, setKey] = useState("null");
	const [search, setSearch] = useState(null);
	const [loading, setLoading] = useState(false);

	const { confirm } = Modal;

	const fetch_order_items = async () => {
		setLoading(true);
		try {
			const res = await get_import_order_history_detail(id);
			const newData = res.items.map((i) => ({
				...i,
				hasChanges: false,
			}));
			setData(newData);
		} catch (error) {
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		if (id) fetch_order_items();
	}, []);

	const onInputChange = (key, index) => (e) => {
		const newData = [...data];

		newData[index][key] = e.target.value;

		newData[index]["hasChanges"] = true;
		setData(newData);
		setHasChanges(true);
	};

	const handleSubmit = () => {
		confirm({
			title: "¿Seguro que quiere publicar estos cambios?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content:
				"Se efectuará la modificación de los registros de manera inmediata",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				confirmPos();
			},
		});
	};

	const confirmPos = async () => {
		try {
			setLoading(true);
			const res = await update_import_order_item_data({ failedItems: data });
			openNotificationWithIcon(
				TYPE.SUCCESS,
				"Los Registros se actualizaron correctamente",
				"Los Registros se actualizaron correctamente"
			);
			// setSearch(null);
			setHasChanges(false);
			fetch_order_items();
		} catch (err) {
			console.log(err);
			openNotificationWithIcon(
				TYPE.ERROR,
				"Los Registros no se pudieron actualizar correctamente, contacte con soporte a soporte@checkpos.com",
				"Los Registros no se pudieron actualizar correctamente, contacte con soporte a soporte@checkpos.com"
			);
		} finally {
			setLoading(false);
		}
	};

	const handleResend = () => {
		confirm({
			title: "¿Seguro que quiere reenviar estos productos?",
			icon: <InfoCircleOutlined style={{ color: "blue" }} />,
			content: "Se enviaran con los datos actuales",
			okText: "Sí",
			okType: "default",
			cancelText: "No",
			onOk: () => {
				confirmResend();
			},
		});
	};

	const confirmResend = async () => {
		try {
			setLoading(true);
			const res = await resend_order_items({
				orders: data,
				clientId: clientId,
				historyId: id,
			});
			if (res?.success) {
				openNotificationWithIcon(
					TYPE.SUCCESS,
					"Ordenes creadas con exito",
					"Todos los registros se han enviado correctamente"
				);
				setHasChanges(false);
				navigate(`/admin/importOrdersHistory`);
			} else {
				openNotificationWithIcon(
					TYPE.WARNING,
					"Existen registros pendientes de envio",
					"Por favor revise los datos y vuelva a enviarlos"
				);
				setHasChanges(false);
				fetch_order_items();
			}
			setHasChanges(false);
			fetch_order_items();
		} catch (err) {
			console.log(err);
			openNotificationWithIcon(
				TYPE.ERROR,
				"Los Registros no se pudieron actualizar correctamente",
				"Contacte con soporte a soporte@checkpos.com"
			);
		} finally {
			setLoading(false);
		}
	};

	const columns = [
		{
			title: () => <div style={{ color: COLORS.White }}>#</div>,
			dataIndex: "opportunityName",
			width: 160,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.DarkGrey,

						fontWeight: "600",
					}}
				>
					{/* <Input
						value={value}
						onChange={onInputChange("opportunityName", index)}
					/> */}
					{value}
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>PDV</div>,
			dataIndex: "posName",
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.DarkGrey,

						fontWeight: "600",
					}}
				>
					{/* <Input value={value} onChange={onInputChange("posName", index)} /> */}
					{value}
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Cuit</div>,
			dataIndex: "cuit",
			width: 140,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.DarkGrey,

						fontWeight: "600",
					}}
				>
					{/* <Input value={value} onChange={onInputChange("cuit", index)} /> */}
					{value}
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Producto</div>,
			dataIndex: "productName",
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.DarkGrey,

						fontWeight: "600",
					}}
				>
					{/* <Input value={value} onChange={onInputChange("productName", index)} /> */}
					{value}
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>EAN</div>,
			dataIndex: "productEan",
			width: 160,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.Grey,

						fontWeight: "600",
					}}
				>
					<Input
						value={value}
						onChange={onInputChange("productEan", index)}
						disabled={loading}
					/>
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Cantidad</div>,
			dataIndex: "productQuantity",
			width: 100,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.Grey,

						fontWeight: "600",
					}}
				>
					<Input
						value={value}
						onChange={onInputChange("productQuantity", index)}
						disabled={loading}
					/>
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Descuento</div>,
			dataIndex: "productDiscount",
			width: 110,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.Grey,

						fontWeight: "600",
					}}
				>
					<Input
						value={value}
						onChange={onInputChange("productDiscount", index)}
						suffix="%"
						disabled={loading}
					/>
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Drogueria</div>,
			dataIndex: "distributorName",
			width: 190,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.DarkGrey,

						fontWeight: "600",
					}}
				>
					{/* <Input
						value={value}
						onChange={onInputChange("distributorName", index)}
					/> */}
					{value}
				</div>
			),
		},
		{
			title: () => <div style={{ color: COLORS.White }}>Codigo cliente</div>,
			dataIndex: "distributorCode",
			width: 130,
			render: (value, record, index) => (
				<div
					style={{
						color: record.hasChanges ? COLORS.White : COLORS.DarkGrey,

						fontWeight: "600",
					}}
				>
					{/* <Input
						value={value}
						onChange={onInputChange("distributorCode", index)}
					/> */}
					{value}
				</div>
			),
		},
	];

	return (
		<Inner>
			<HeaderContainer>
				<Main.Breadcrumb>
					<Main.BreadcrumbItem>
						<Link to="/">Home</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.BreadcrumbItem>
						<Link to="/admin/importOrdersHistory">Historial</Link>
					</Main.BreadcrumbItem>
					<Main.BreadcrumbSeparator />
					<Main.ActiveBreadcrumbItem>Registros</Main.ActiveBreadcrumbItem>
				</Main.Breadcrumb>
			</HeaderContainer>
			<Main.Body>
				<ConfirmButton>
					{hasChanges && (
						<AntdButton onClick={handleSubmit} success loading={loading}>
							Confirmar cambios
						</AntdButton>
					)}
					{!hasChanges && (
						<AntdButton onClick={handleResend} loading={loading}>
							Reenviar productos
						</AntdButton>
					)}
				</ConfirmButton>
				{!data ? (
					<LoadingSkeleton />
				) : (
					<TableContainer>
						<AntdTable
							dataSource={data}
							columns={columns}
							pagination={false}
							rowClassName={(record) =>
								record.hasChanges ? "hasChanges" : null
							}
							scroll={{
								y: 1600,
							}}
						/>
					</TableContainer>
				)}
			</Main.Body>
		</Inner>
	);
}
